<style>
    .print-direction-vertical-line{
        background-color: initial !important;
        border: 1.2px solid #ccc;
        width: 0 !important;
        border-style: dashed;
    }
</style>

<template>
    <div class="row step">
        <div class="col-1 overflow-hidden position-relative">
            <div class="time d-flex align-items-center justify-content-end">
                <div class="circle-icon" :class="{'bg-white': true}">
                    <svg-icon v-if="!isNavigation()" color="#4547BF" :name="icon.name" height="auto" width="15"/>
                    <svg-icon v-else name="three-dots" height="auto" width="20"/>
                </div>
            </div>
            <div v-if="direction.position !== 'last'" class="vertical-line print-direction-vertical-line position-absolute"></div>
        </div>
        <div v-if="direction.show_as === 'direction'" class="col-11 pl-0">
            <div class="details">
                <div class="card mt-2">
                    <div class="card-body">
                        <h2 class="fw-normal" v-html="direction.direction.html_instructions"></h2>
                        <span>{{ direction.direction.distance.text }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="direction.position !== 'last'" class="col-1 overflow-hidden position-relative h-1">
            <div class="vertical-line print-direction-vertical-line position-absolute"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'direction',
    props: ['direction', 'type'],
    data() {
        return {
        }
    },
    computed: {
        icon() {
            return this.type
        },
    },
    methods: {
        emitShow(type) {
            this.$emit('navigate', type)
        },
        isNavigation() {
            return this.direction.show_as === 'backwards' || this.direction.show_as === 'forward'
        },
    },
}
</script>
